export default __webpack_public_path__ + "static/media/897.939b77c4.gif";